module.exports = __webpack_public_path__ + "static/img/MemberCard.be481cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MemberCard.png
// module id = 4kLT
// module chunks = 1